export const isComparisonValid = ({ op, value }) => {
  if (op === 'ILIKE') {
    return Boolean(value);
  }

  if (op === 'IS NULL' || op === 'future' || op === 'past' || op === 'blank') {
    return true;
  }

  return Boolean(op && !(value === null || value === undefined));
};
